// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"41":"56a3ad1fc4b1ffce","185":"6368f4edad220710","719":"8f9d0f1101650494"}[chunkId] + ".css";
};